import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityCondition } from "../../entity/EntityCondition";

export class DtoConditionsGetRes extends EntityCondition {
  public items: EntityCondition[]  = [];
}
